const drafts = [
  {
    id: 0,
    content: "Some people probably think schoolwork is completely boring and couldn’t be any more different from video games. To tell you the truth, you know those things you study at school? It’s when you start making video games that they become important.",
  },
  {
    id: 1,
    content: "信言不美，美言不信。善者不辩，辩者不善。知者不博，博者不知。",
  },
  {
    id: 2,
    content: "爱是海，喜欢是海啸，而人是孤岛。",
  },
  {
    id: 3,
    content: "世界很大，你要说话。",
  },
  {
    id: 4,
    content: "人群纷扰不断联。Keep Online, Get Back.",
  },
  {
    id: 5,
    content: "看过了你，才知道沉沦的美丽。",
  },
  {
    id: 6,
    content: "晚安～",
  },
  {
    id: 7,
    content: "速写速写速写速写速写速写速写速写速写速写这里是速写，就像速写，拿起铅笔在纸上随意勾勒和涂改。就像速写，拿起铅笔在纸上随意勾勒和涂改。",
  }
];

export default drafts;